/** Merchants list [351:3041](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=351-3041) · Approve/Reject modals [351:2749](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=351-2749) */
export const ADMIN_MERCHANTS_PATH = '/admin/merchants'

export const ADMIN_MERCHANTS = {
  headerLabel: 'MERCHANT',
  subtitle: 'Manage and monitor platform merchants.',
  searchPlaceholder: 'Search by name, ID, or loca…',
  exportLabel: 'Export CSV',
  newMerchantLabel: '+ New Merchant',
  tabs: [
    { id: 'all', label: 'All' },
    { id: 'pending', label: 'Pending', count: 12 },
    { id: 'active', label: 'Active' },
    { id: 'suspended', label: 'Suspended' },
    { id: 'rejected', label: 'Rejected' },
  ],
  columns: {
    business: 'Business',
    typeLocation: 'Type & Location',
    status: 'Status',
    verification: 'Verification',
    metrics: 'Metrics',
    joined: 'Joined',
    actions: 'Actions',
  },
  pagination: {
    showingPrefix: 'Showing',
    showingRange: '1-3',
    showingSuffix: 'of 1,204 merchants',
  },
  merchants: [
    {
      id: 'M-8821A',
      name: 'Neon Brews',
      logoTone: 'bg-orange-50 text-rapid-orange',
      logoGlyph: 'NB',
      type: 'F&B',
      typeTone: 'bg-emerald-50 text-emerald-700',
      location: 'Lagos, NG',
      status: 'active',
      statusLabel: 'Active',
      verification: 'tier_3',
      verificationLabel: 'Tier 3',
      orders: '1,240',
      gmv: '₦4.2M',
      joined: 'Oct 12, 2023',
    },
    {
      id: 'MC-8824',
      name: 'Acme Corp Logistics',
      logoTone: 'bg-emerald-50 text-emerald-700',
      logoGlyph: 'AC',
      type: 'Enterprise Fleet',
      typeTone: 'bg-amber-50 text-amber-700',
      location: 'Abuja, NG',
      status: 'review',
      statusLabel: 'Review',
      verification: 'docs_required',
      verificationLabel: 'Docs Req.',
      orders: '--',
      gmv: '₦0.00',
      joined: 'Today, 09:41',
      reviewable: true,
      approveContext: {
        id: 'MC-8824',
        name: 'Acme Corp Logistics',
        entityType: 'Enterprise Fleet',
        riskScore: 'Low (12/100)',
        riskTone: 'text-emerald-600',
        contactName: 'Jane Doe',
        contactEmail: 'j.doe@acme.logistics',
      },
      rejectContext: {
        id: 'MC-8824',
        name: 'Acme Corp Logistics',
      },
    },
    {
      id: 'MC-7714',
      name: 'Global Trade Partners Ltd',
      logoTone: 'bg-rose-50 text-rose-600',
      logoGlyph: 'GT',
      type: 'Wholesale',
      typeTone: 'bg-gray-100 text-gray-700',
      location: 'Kano, NG',
      status: 'review',
      statusLabel: 'Review',
      verification: 'docs_required',
      verificationLabel: 'Docs Req.',
      orders: '--',
      gmv: '₦0.00',
      joined: 'Yesterday, 14:12',
      reviewable: true,
      approveContext: {
        id: 'MC-7714',
        name: 'Global Trade Partners Ltd',
        entityType: 'Wholesale Network',
        riskScore: 'Medium (34/100)',
        riskTone: 'text-amber-600',
        contactName: 'Samuel Adeyemi',
        contactEmail: 's.adeyemi@globaltp.ng',
      },
      rejectContext: {
        id: 'MC-7714',
        name: 'Global Trade Partners Ltd',
      },
    },
    {
      id: 'M-4410A',
      name: 'Aura Apparel',
      logoTone: 'bg-gray-900 text-white',
      logoGlyph: 'AA',
      type: 'Fashion',
      typeTone: 'bg-violet-50 text-violet-700',
      location: 'Port Harcourt, NG',
      status: 'active',
      statusLabel: 'Active',
      verification: 'tier_2',
      verificationLabel: 'Tier 2',
      orders: '845',
      gmv: '₦1.8M',
      joined: 'Nov 02, 2023',
    },
  ],
  mobile: {
    pageTitle: 'Merchants',
    searchPlaceholder: 'Search businesses, ID, or phone...',
    totalOrdersLabel: 'Total Orders',
    filters: [
      { id: 'all', label: 'All' },
      { id: 'pending', label: 'Pending', badge: '12' },
      { id: 'active', label: 'Active' },
      { id: 'suspended', label: 'Suspended' },
      { id: 'rejected', label: 'Rejected' },
    ],
    merchants: [
      {
        id: 'M-MAMA',
        name: 'Mama Cass',
        category: 'Food & Beverage',
        categoryIcon: 'utensils',
        location: 'Victoria Island',
        status: 'active',
        statusLabel: 'Active',
        logoKind: 'gradient',
        logoBg: 'linear-gradient(135deg, #3F2A1E 0%, #1F1410 100%)',
        logoText: 'MC',
        logoTextColor: '#F0C268',
        orders: '1,245',
        actionLabel: 'View Details',
        actionType: 'view',
      },
      {
        id: 'M-TECH',
        name: 'Tech Hub NG',
        category: 'Electronics',
        categoryIcon: 'monitor',
        location: 'Ikeja',
        status: 'pending',
        statusLabel: 'Pending',
        statusIcon: 'zap',
        logoKind: 'icon',
        logoIcon: 'shopping-bag',
        orders: '0',
        actionLabel: 'Review',
        actionType: 'review',
      },
      {
        id: 'M-FRESH',
        name: 'Fresh Mart',
        category: 'Groceries',
        categoryIcon: 'shopping-cart',
        location: 'Lekki',
        status: 'suspended',
        statusLabel: 'Suspended',
        logoKind: 'gradient',
        logoBg: 'linear-gradient(135deg, #4A5D4F 0%, #2E3A33 100%)',
        logoText: 'FM',
        logoTextColor: '#E6F2D9',
        orders: '8,432',
        actionLabel: 'View Log',
        actionType: 'log',
        dimmed: true,
        strikethrough: true,
      },
    ],
    bottomNav: [
      { id: 'overview', label: 'Overview', icon: 'bar-chart', path: '/admin' },
      { id: 'users', label: 'Users', icon: 'users-search', path: '/admin/users' },
      {
        id: 'merchants',
        label: 'Merchants',
        icon: 'store',
        path: '/admin/merchants',
        active: true,
      },
    ],
  },
}

export function getAdminMerchantById(merchantId) {
  return (
    ADMIN_MERCHANTS.merchants.find((m) => m.id === merchantId) ??
    ADMIN_MERCHANTS.merchants[0]
  )
}

export const ADMIN_APPROVE_MERCHANT_MODAL = {
  title: 'Approve Merchant',
  summaryTitle: 'Application Summary',
  idLabel: 'ID',
  entityTypeLabel: 'Entity Type',
  riskScoreLabel: 'Risk Score',
  primaryContactLabel: 'Primary Contact',
  checklistTitle: 'Verification Checklist',
  checklist: [
    'KYC/AML documentation verified',
    'Banking details confirmed',
    'Service Level Agreement signed',
  ],
  notify: {
    title: 'Notify Merchant',
    description: 'Send automated welcome email and platform credentials.',
    defaultOn: true,
  },
  cancelLabel: 'Cancel',
  confirmLabel: 'Approve Merchant',
}

export const ADMIN_REJECT_MERCHANT_MODAL = {
  title: 'Reject Merchant',
  reasonLabel: 'Rejection Reason',
  reasonPlaceholder: 'Select a primary reason…',
  reasons: [
    { id: 'incomplete_docs', label: 'Incomplete documentation' },
    { id: 'failed_kyc', label: 'Failed KYC verification' },
    { id: 'risk_too_high', label: 'Risk score too high' },
    { id: 'duplicate_application', label: 'Duplicate application' },
    { id: 'restricted_category', label: 'Restricted business category' },
    { id: 'other', label: 'Other (specify in message)' },
  ],
  messageLabel: 'Message to Merchant',
  messageRequiredLabel: 'Required',
  messagePlaceholder:
    'Provide details regarding the rejection. This will be sent to the merchant…',
  reapply: {
    title: 'Allow Reapplication',
    description: 'Merchant can submit a new application after 30 days.',
    defaultOn: false,
  },
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm Rejection',
}
